import React from 'react'
import useSWR from 'swr'
import Fetcher from '@lib/fetcher'

// Booking-fee disclosure shown on the booking pathway.
//
// The displayed text is the venue's Custom Website Message scraped from
// Spektrix's chooseseats.aspx iframe — see BookingFeeMessage on the
// server. We render it verbatim so the venue can edit both the wording
// AND the embedded fee value in Spektrix admin, no code change required.
//
// /booking_fee returns { amount, text }. We use `text` directly; `amount`
// is kept on the endpoint for other consumers and as a cross-check.
const BookingFeeDisclosure = ({ className }) => {
  const { data } = useSWR('/booking_fee', Fetcher)
  const text = data?.text

  if (typeof text !== 'string' || text.length === 0) return null

  return (
    <p
      className={className || 'text-sm text-gray-600 dark:text-gray-400'}
    >
      {text}
    </p>
  )
}

export default BookingFeeDisclosure
